App.factory('PaymentStatusUpdate', ['restmod', (restmod) => {
  return restmod.model()
}])
